<template>
    <Popper :trigger="trigger" :options="options">
        <div class="popper">
            <slot></slot>
        </div>

        <div slot="reference">
            <slot name="trigger"></slot>
        </div>
    </Popper>
</template>
<script>
    import Popper from 'vue-popperjs';
    import 'vue-popperjs/dist/vue-popper.css';

    export default {
        name: 'Tooltip',
        components: {
            Popper
        },
        props: {
            options: {
                type: Object,
                default: function () { return { placement: 'top', modifiers: { offset: { offset: '0,10px' } } } }
            },
            trigger: {
                type: String,
                default: 'hover'
            }
        },
        data () {
            return {
            }
        },
        computed: {

        },
        mounted () {
            let self = this;
            document.addEventListener("click", function(){
                self.show = false;
            });
        },
        methods: {
            toggle: function(e) {
                e.stopPropagation();
                this.show = !this.show;
            }

        }
    }
</script>
<style src="./Tooltip.scss" lang="scss"></style>

